module.exports = __webpack_public_path__ + "img/icn_green_whats.431a6203.svg";